// extracted by mini-css-extract-plugin
module.exports = {"galeryGrid":"uD","arrowContainer":"uE","galeryLogo":"uF","noImageText":"uG","button":"uH","galeryRow":"uI"};